export const SET_TOR_TAB = 'SET_TOR_TAB';
export const SET_TOR_TAB_PAGE = 'SET_TOR_TAB_PAGE';
